import { TextField } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { Controller, useFormContext } from "react-hook-form";

const CFormTextField = React.forwardRef(
  (
    {
      label,
      disabled,
      name,
      type,
      helperText,
      handleChange,
      multiline,
      placeholder,
      ...other
    },
    ref
  ) => {
    const { control } = useFormContext();

    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            type={
              type === "password"
                ? "password"
                : type === "number"
                ? "number"
                : "text"
            }
            InputLabelProps={{ shrink: !!(value !== undefined && value !== null && value !== '') }}
            className={
              multiline
                ? "CTextarea !text-blue-500 !font-[Poppins]"
                : "2xl:!mt-5 !mt-4 custom-input !text-blue-500 !font-[Poppins]"
            }
            ref={ref}
            multiline={multiline && multiline}
            disabled={disabled}
            fullWidth
            label={label}
            placeholder={placeholder}
            value={typeof value === "number" && value === 0 ? "" : value}
            error={!!error}
            onChange={(e) => {
              onChange(e);
              handleChange && handleChange(e.target.value);
            }}
            helperText={error ? error?.message : helperText}
            {...other}
          />
        )}
      />
    );
  }
);

CFormTextField.propTypes = {
  name: PropTypes.string,
  helperText: PropTypes.node,
};
export default CFormTextField;
